import React from "react";

/**
 * Componente de barra de filtros para distribuições
 */
const FilterBar = ({ 
  statusOptions, 
  selectedStatus, 
  onStatusChange,
  dataInicio,
  dataFim,
  numeroProcesso,
  onDataInicioChange,
  onDataFimChange,
  onNumeroProcessoChange
}) => {
  const inputCls = "px-3 py-2 text-sm border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-ring bg-white";

  return (
    <div className="bg-white rounded-xl border border-border p-4 mb-4 flex flex-wrap gap-4 items-end">
      <div className="flex flex-col gap-1">
        <label htmlFor="data-inicio" className="text-xs font-medium text-muted-foreground">Data Início</label>
        <input type="date" id="data-inicio" value={dataInicio} onChange={onDataInicioChange} className={inputCls} />
      </div>

      <div className="flex flex-col gap-1">
        <label htmlFor="data-fim" className="text-xs font-medium text-muted-foreground">Data Fim</label>
        <input type="date" id="data-fim" value={dataFim} onChange={onDataFimChange} className={inputCls} />
      </div>

      <div className="flex flex-col gap-1">
        <label htmlFor="processo-filter" className="text-xs font-medium text-muted-foreground">Processo</label>
        <input
          type="text" id="processo-filter" value={numeroProcesso} onChange={onNumeroProcessoChange}
          placeholder="Número do processo" className={`${inputCls} min-w-[180px]`}
        />
      </div>

      <div className="flex flex-col gap-1">
        <label htmlFor="status-filter" className="text-xs font-medium text-muted-foreground">Status</label>
        <select id="status-filter" value={selectedStatus} onChange={onStatusChange} className={inputCls}>
          {statusOptions.map(option => (
            <option key={option.key} value={option.key}>{option.value}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FilterBar;
